import { useState , useEffect , useRef } from 'react';
import { produce } from 'immer';
import useRefState from 'js/Utils/Hooks/useRefState.js';

const fetchTranslationGroup = async ( handle , language )=>{
    let response = await fetch(  '/translations/' + encodeURI( handle ) +'/' + encodeURI( language ) ,  {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json' ,
            'Accept': 'application/json'  ,
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    }  );

    if( response.status == 200 ){
            let json = await response.json();
            return json ;
    }  

    throw new Error('Translations not found');
}

const useTranslationGroup = ( handle , language  , prefetchedData ) => {
    const [ currentFetchedLanguage , setCurrentFetchedLanguage ] = useRefState( (prefetchedData ? language: null) );
    const [ prevFetchedLanguage , setPrevFetchedLanguage ] = useRefState( null );
    const [ prevTransGroup , setPrevTransGroup ] = useRefState({});
    const [ errorFetchingCurrentTranslations , setErrorFetchingCurrentTranslations ] = useRefState(false);
    const inFetchTranslations = useRef(false);

    const [translations , setTranslations ] = useRefState((prefetchedData ? language: {}));
    const [translationsInitialized , setTranslationsInitialized ] = useRefState( ( prefetchedData ?  true : false ));


    useEffect( ()=>{
        if(language){
          if( !inFetchTranslations.current && currentFetchedLanguage() != language ){
             ( async ()=>{
                inFetchTranslations.current = true;
                try{
                    const translationGroupDataFetched = await fetchTranslationGroup(handle , language );;
                    
                    setPrevFetchedLanguage(currentFetchedLanguage());
                    setPrevTransGroup(produce( translations , ()=>{}));
                    setTranslations(translationGroupDataFetched);
                    setCurrentFetchedLanguage(language);
                    setErrorFetchingCurrentTranslations(false);
                } catch(e){
                    
                    setPrevFetchedLanguage(currentFetchedLanguage());
                    setPrevTransGroup(produce( translations , ()=>{}));
                    setCurrentFetchedLanguage(language);
                    setTranslations({});
                    if( e.message == 'Failed to fetch'){
                      // handle offline retry
                    } 
                }
  
                inFetchTranslations.current = false;
  
                setTranslationsInitialized(true);
            })();
          }  
        }
      },[ language ]);

    let mostRecentFetchedLanguage = ( errorFetchingCurrentTranslations() ? [ prevTransGroup() , prevFetchedLanguage() ] : [ translations() , currentFetchedLanguage() ]);
    console.log( 'mostRecentFetchedLanguage' , mostRecentFetchedLanguage);
    return [ translationsInitialized() , currentFetchedLanguage() , translations() ,  prevFetchedLanguage() , prevTransGroup()  , mostRecentFetchedLanguage[0] , mostRecentFetchedLanguage[1] ] ;
}

export default fetchTranslationGroup;

export { useTranslationGroup };